
export default "/assets/calendar-micro.6df03109.svg"